import React from 'react'
import { css, Global } from '@emotion/core'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'

import ContactUsButton from '@sputnik/components/ContactUsButton'
import ImageWrapper from '@sputnik/components/ImageWrapper'
import { PRODUCT_CONST_STRINGS } from '@sputnik/resources/constants'

const MaintenanceScreen = () => {
  const [getClassName, makeTestId] = useNameFormatter('MaintenanceScreen')

  return (
    <div
      className={getClassName('')}
      css={maintenanceScreenStyles}
      data-testid={makeTestId('')}
    >
      <ImageWrapper
        alt='road-barricade'
        className={getClassName('road-barricade-img')}
        dataTestId={makeTestId('img')}
        imageName='road-barricade'
      />
      <div
        className={getClassName('heading')}
        data-testid={makeTestId('heading')}
      >
        <FormattedMessage
          defaultMessage="We'll be back soon"
          id='sputnik.MaintenanceScreen__GM4TRa'
        />
      </div>
      <div
        className={getClassName('sub-heading')}
        data-testid={makeTestId('sub-heading')}
      >
        <FormattedMessage
          defaultMessage="We're working on making the {BILL_SPEND_AND_EXPENSE} application better for our customers. Please check back later to access your application."
          id='sputnik.MaintenanceScreen__QQRA1N'
          values={{ BILL_SPEND_AND_EXPENSE: PRODUCT_CONST_STRINGS.BILL_SPEND_AND_EXPENSE }}
        />
      </div>
      <div className={getClassName('sub-heading')}>
        <FormattedMessage
          defaultMessage='Thanks for your patience.'
          id='sputnik.MaintenanceScreen__hYQpHO'
        />
      </div>
      <div
        className={getClassName('cta-container')}
        data-testid={makeTestId('cta-conatiner')}
      >
        <ContactUsButton />
      </div>
      <Global
        styles={css`
          .grecaptcha-badge {
            display: none;
          }
        `}
      />
    </div>
  )
}

const maintenanceScreenStyles = ({ type }) => css`
  max-width: 450px;
  padding: 0 var(--tri-space-300);
  margin: 0 auto;
  text-align: center;

  .ImageWrapper-MaintenanceScreen-road-barricade-img {
    margin-top: var(--tri-space-2200);
    max-width: 300px;
  }

  .MaintenanceScreen {
    &-heading {
      ${type.triFontDesktopTitleLargeEmphasis}
      margin-bottom: var(--tri-space-300);
    }

    &-sub-heading {
      ${type.triFontDesktopBodyMedium}
      margin-bottom: var(--tri-space-200);
    }

    &-cta-container {
      display: flex;
      justify-content: center;
      margin-top: var(--tri-space-500);
    }
  }
`

export default MaintenanceScreen
